<template>
  <div
    class="cta-block px-auto relative mx-[25px] mt-[25px] h-auto w-auto content-center rounded-[10px] bg-white bg-[length:300px_320px] bg-right bg-no-repeat py-[35px] drop-shadow-2xl xl:mx-auto xl:mt-[100px] xl:flex xl:h-[166px] xl:w-[1200px] xl:px-[46px]"
  >
    <div class="my-auto ml-0 w-auto text-center xl:w-[550px] xl:text-left">
      <h2
        class="mx-auto text-[48px] font-extrabold leading-[48px] tracking-[.42px] text-[#333]"
      >
        {{ ctaHeadline }}
      </h2>
      <h3
        class="mt-[5px] px-[5px] text-sm font-medium leading-[25px] text-[#7c828d] lg:px-0"
      >
        Customer support is our highest priority. We're here to answer all your
        questions via our Support Docs, Video Demos, and 24/7 Live Chat.
      </h3>
    </div>

    <div class="mx-auto mt-[30px] flex sm:my-auto sm:mt-[30px]">
      <Form
        action="get"
        class="z-20 mx-auto text-2xl sm:flex sm:max-w-4xl sm:text-3xl"
        @submit="handleSubmit"
        :validation-schema="schema"
        v-slot="{ errors }"
      >
        <div>
          <Field
            as="input"
            type="text"
            name="email"
            class="email_capture peer mx-auto mt-0 mb-[15px] block h-[50px] w-full rounded-[4px] border border-l-[5px] border-l-[#27AE60] bg-[left_16px_top_15px] bg-no-repeat py-0 pl-[46px] text-sm placeholder-[#D1D1D1] shadow-lg focus:outline-none sm:mb-0 md:rounded-tr-none md:rounded-br-none lg:w-[300px]"
            placeholder="Enter Your Work Email"
            :class="{
              'border-red-500': errors.email,
              '': !errors.email
            }"
            v-model="formData.email"
          />
          <ErrorMessage name="email" class="text-red-400 text-xs mt-2" />
        </div>
        <!-- backend error -->
        <div class="py-2" v-if="backEndError">
          <p class="text-red-400 text-center">
            {{ backEndError }}
          </p>
        </div>
        <!-- actions -->
        <div>
          <button
            class="mx-auto h-[50px] w-[300px] rounded-[4px] bg-[#2D8CFF] p-1.5 text-[16px] font-bold text-white shadow-[#2D8Cff] transition ease-in hover:bg-[#0f61c5] active:bg-[#054ca3] dark:border-none sm:w-[125px] sm:rounded-tl-none sm:rounded-bl-none sm:text-[14px]"
            type="submit"
            :disabled="isLoading['submit']"
          >
            <LoaderComponent
              :isReactive="isLoading['submit']"
            ></LoaderComponent>
            {{ isLoading['submit'] ? '' : 'Get Started' }}
          </button>
        </div>
      </Form>
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted } from 'vue';
import { useReCaptcha } from 'vue-recaptcha-v3';
import LoaderComponent from '../../../shareComponents/js/Components/LoaderComponent.vue';
import Axios from 'axios';
import { Form, Field, ErrorMessage } from 'vee-validate';
import * as yup from 'yup';

const isLoading = reactive({});
const backEndError = ref('');
const { executeRecaptcha, recaptchaLoaded } = useReCaptcha();

const props = defineProps({
  ctaHeadline: {
    type: String,
    required: false
  }
});

const formData = reactive({
  email: ''
});

const schema = yup.object({
  email: yup.string().required('Please provide an email').email()
});

const handleSubmit = async () => {
  isLoading['submit'] = true;

  try {
    const recaptcha_token = await handleRecaptcha();

    const formDataToSubmit = createFormData(formData, recaptcha_token);

    const res = await postFormData(formDataToSubmit);

    handleRes(res);
  } catch (err) {
    console.log(err);

    isLoading['submit'] = false;

    backEndError.value = err.response.data.message;
  }
};

const handleRecaptcha = async () => {
  await recaptchaLoaded();
  const recaptcha_token = await executeRecaptcha('login');
  return recaptcha_token;
};

const createFormData = (dataObject, recaptcha_token) => {
  let formDataToSubmit = new FormData();

  Object.keys(dataObject).forEach((key) => {
    formDataToSubmit.append(key, dataObject[key]);
  });

  formDataToSubmit.append('recaptcha_token', recaptcha_token);

  return formDataToSubmit;
};

const postFormData = async (formDataToSubmit) => {
  try {
    let response = await Axios({
      method: 'post',
      url: '/free-signup-quick-survey/captureEmail',
      data: formDataToSubmit,
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
    return response;
  } catch (error) {
    throw error;
  }
};

const handleRes = (res) => {
  // console.log(res);
  if (res.status === 204 || res.status === 200) {
    window.location.href = '/free-signup-quick-survey';
    isLoading['submit'] = false;
  }
  // else {
  //   backEndError.value = res.data.message;
  // }
  isLoading['submit'] = false;
};
</script>

<style scoped>
.cta-block {
  background-image: url(../media/images/two-dots.svg);
  background-size: auto;
}
.email_capture {
  background-image: url(../media/images/green-course-platform-letter.svg);
}
</style>
